import React, { useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import PopUpVariantTwo from '../PopUpVariantTwo';
import PopUpVariantOne from '../PopUpVariantOne';
import PopUpVariantThree from '../PopUpVariantThree';
import useResizer from '@components/extra/useResizer';
import useMarketingPopupEvents from '@src/hooks/useMarketingPopupEvents';
import { EPopupType } from '@src/constants/general/index';
import { useLocation } from '@reach/router';

const TrialUser = ({ setOpen, variant }) => {
  const isMobile = useResizer();
  const location = useLocation();

  const isQAPage = location.pathname.includes('/qa-automation-testing');

  const getCampaignByVariant = () => {
    if (variant === 1) {
      return 'new-1';
    } else if (variant === 7) {
      return 'trial-1';
    }

    return `return-${variant - 1}`;
  };

  const utmParams = {
    utmSource: 'website',
    utmMedium: 'pop-up',
    utmCampaign: getCampaignByVariant(),
  };

  const onButtonClick = () => {
    if (!isMobile) {
      setOpen(false);
    }
  };

  const { popupViewHandler } = useMarketingPopupEvents();

  useEffect(() => {
    popupViewHandler(variant);
  }, []);

  const getPopupByVariant = (variant) => {
    switch (variant) {
      case 1:
        return (
          <PopUpVariantOne
            title={'You’re Awesome!'}
            description={
              <>
                For wanting to upskill and accelerate your tech career. Book a
                free trial session to see how we will help you achieve your
                goals.
              </>
            }
            image={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/CrioCelebration.webp'}
                className="h-full w-[280px] rounded-l-[20px]"
                placeholder="blurred"
                alt="About Us"
                width={280}
              />
            }
            mobileImage={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/CrioCelebrationMobile.webp'}
                className="h-full w-full rounded-t-[12px]"
                placeholder="blurred"
                alt="About Us"
                width={312}
              />
            }
            onButtonClick={onButtonClick}
            utmParams={utmParams}
            variant={variant}
          />
        );

      case 2:
        return (
          <PopUpVariantTwo
            title={'You’re Awesome!'}
            description={
              <>
                It’s great to see you back! Ready to continue your journey? Dive
                into our latest programs and challenges to keep advancing your
                skills.
              </>
            }
            image={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/PopupImage2.webp'}
                className="h-[170px] w-[170px] translate-y-6 rounded-t-[12px] md:h-[300px]  md:w-[300px] md:translate-y-0"
                placeholder="blurred"
                alt="About Us"
                width={245}
              />
            }
            buttonText={'Get Started'}
            onButtonClick={onButtonClick}
            utmParams={utmParams}
            variant={variant}
          />
        );

      case 3:
        return (
          <PopUpVariantOne
            title={
              isQAPage
                ? 'Crack QA Automation roles in top tech companies. Get insights now.'
                : 'Crack full stack or backend roles in top tech companies. Get insights now.'
            }
            description={''}
            image={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/PaperPlane.webp'}
                className="h-full w-[280px] rounded-l-[20px]"
                placeholder="blurred"
                alt="About Us"
                width={280}
              />
            }
            mobileImage={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/PaperPlaneMobile.webp'}
                className="h-full w-full rounded-t-[12px]"
                placeholder="blurred"
                alt="About Us"
                width={312}
              />
            }
            onButtonClick={onButtonClick}
            utmParams={utmParams}
            variant={variant}
            type={EPopupType.DOWNLOAD_CURRICULUM}
            buttonText={'Get your ticket NOW!'}
          />
        );

      case 4:
        return (
          <PopUpVariantOne
            title={'Unlock Your Next Career Milestone!'}
            description={
              <>
                You’re just one step away from unlocking the next step to your
                dream career! Discover how{' '}
                <strong className="text-black">#LearnByDoing</strong> can
                advance your tech career forward
              </>
            }
            image={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/CrioKey.webp'}
                className="h-full w-[280px] rounded-l-[20px]"
                placeholder="blurred"
                alt="About Us"
                width={280}
              />
            }
            mobileImage={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/CrioKeyMobile.webp'}
                className="h-full w-full rounded-t-[12px]"
                placeholder="blurred"
                alt="About Us"
                width={312}
              />
            }
            onButtonClick={onButtonClick}
            utmParams={utmParams}
            buttonText={'Unlock Now'}
            variant={variant}
          />
        );

      case 5:
        return (
          <PopUpVariantTwo
            title={'Don’t Go Without Your Scholarship!'}
            description={
              <>
                You're back, and to celebrate, we have a limited-time
                scholarship just for you! Apply now and grab scholarships worth{' '}
                <strong>₹60,000</strong>.
              </>
            }
            image={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/PopupImage1.webp'}
                className="h-[150px] w-[150px] rounded-t-[12px] md:h-[300px] md:w-[300px]"
                placeholder="blurred"
                alt="About Us"
                width={245}
              />
            }
            buttonText={'Grab Scholarship Now'}
            onButtonClick={onButtonClick}
            utmParams={utmParams}
            variant={variant}
          />
        );

      case 6:
        return (
          <PopUpVariantOne
            title={'Here’s your ticket to the big leagues'}
            description={
              <>
                Ready to land a job at a top tech giant? This is your chance to
                make it happen. Join us and take the next step toward your dream
                career.
              </>
            }
            image={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/CrioCoupon.webp'}
                className="h-full w-[280px] rounded-l-[20px]"
                placeholder="blurred"
                alt="About Us"
                width={280}
              />
            }
            mobileImage={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/CrioCouponMobile.webp'}
                className="h-full w-full rounded-t-[12px]"
                placeholder="blurred"
                alt="About Us"
                width={312}
              />
            }
            onButtonClick={onButtonClick}
            utmParams={utmParams}
            variant={variant}
            buttonText={'Get your ticket NOW!'}
          />
        );

      case 7:
        return (
          <PopUpVariantThree
            title={'You Got a Free Invite!'}
            description={
              <>
                Now it’s time to act. Experience how{' '}
                <strong>#LearnByDoing</strong> can accelerate your tech skills.
                Our <strong>FREE</strong> trial session starts soon. Reserve
                your spot <strong>NOW!</strong>
              </>
            }
            image={
              <StaticImage
                loading="lazy"
                src={'../../../images/popup/Invite.webp'}
                className="h-full w-[140px] rounded-l-[20px]"
                placeholder="blurred"
                alt="About Us"
                width={280}
              />
            }
            buttonText={'Join Now!'}
            onButtonClick={onButtonClick}
            utmParams={utmParams}
            variant={variant}
          />
        );

      default:
        return <></>;
    }
  };

  return <>{getPopupByVariant(variant)}</>;
};

export default TrialUser;
